import axios from 'axios'
import config from './config'
import store from '../store'
import router from '../router'
import hui from 'h_ui/dist/h_ui.min.js'
import Cookies from 'js-cookie'
import { getUrlParam } from '@/utils'
import Vue from 'vue'
const httpFetch = axios.create({
  ...config,
  baseURL: window.LOCAL_CONFIG.API_HOME
})
// request拦截器
httpFetch.interceptors.request.use(
  config => {
    config.headers['Access-Token'] = window.sessionStorage.getItem(
      'Access-Token'
    )
      ? window.sessionStorage.getItem('Access-Token')
      : ''
    config.timeout = 20000
    config.data = config.data ? config.data : {}
    return config
  },
  error => {
    //console.log(error)
    return Promise.reject(error)
  }
)
httpFetch.interceptors.response.use(
  response => {
    if (
      response.code == 'ECONNABORTED' &&
      response.message.indexOf('timeout') != -1
    ) {
      hui.hMessage.error('网络异常，请重试')
    }
    if (
      response.headers['content-type'] ==
      'application/octet-stream;charset=UTF-8'
    ) {
      return response
    }
    if (response.headers['content-type'] == 'application/octet-stream') {
      return response
    }
    if (response) {
      const status = response.status
      if (status === 200 || status === 304 || status === 400) {
        if (response.data && typeof response.data == 'string') {
          response.data = JSON.parse(response.data)
        }
        if (response.config.errorHandler) {
          return response.data
        }
        if (response.data.error_code == '0' || response.data.error_code == '') {
          return response.data.data
        } else {
          checkUserState(response.data.error_code, response.data.error_info)
        }
      } else {
        checkStatus(status)
      }
    }
  },
  error => {
    return Promise.reject(error)
  }
)

function checkStatus(status) {
  let errorInfo = ''
  switch (status) {
    case -1:
      errorInfo = '远程服务响应失败,请稍后重试'
      break
    case 500:
      errorInfo = '500：访问服务失败'
      break
    case 403:
      errorInfo = '请不要输入非法字符！'
      break
    case 404:
      errorInfo = '404：资源不存在'
      break
  }
  hui.hMessage.error(errorInfo)
}
function checkUserState(errorCode, errorInfo) {
  if (errorCode == '100002') {
    // 未登录就跳转登录
    Vue.prototype.$goLoginUrl()
    return;
  }
  const stateMap = new Map([
    ['120002', '对不起，该服务仅限实名认证的用户购买,请前往实名认证'],
    ['120003', '对不起，该服务仅限实名认证的用户购买,请查看实名审核'],
    ['120004', '对不起，该服务仅限实名认证的企业用户购买,请前往实名认证'],
  ]);
  if (stateMap.has(errorCode)) {
    let content = stateMap.get(errorCode)
    hui.hMsgBox.confirm({
      title: '实名提示',
      content: content,
      onOk: () => {
        window.location.href = '/cloud-console/account/authentication'
      },
      onCancel: () => { }
    })
  } else {
    hui.hMessage.info(errorInfo)
  }
}
export default httpFetch



// WEBPACK FOOTER //
// ./src/gtn/api/httpFetch.js